import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { ExpenseRepositoryBase } from '@skylab-shared/business';
export { ExpenseRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(ExpenseRepositoryBase)
export class ExpenseRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
